import { Controller } from "@hotwired/stimulus"

// Syncs the city edit page H1 with the name field (textContent only; no innerHTML).
// The name field is wired as data-admin-city-edit-title-target="nameInput" from the form
// when live heading is enabled, so this does not depend on hard-coded param names or querySelector.
export default class extends Controller {
  static targets = ["title", "nameInput"]

  connect() {
    this.syncFromDom()
  }

  syncFromEvent(event) {
    if (!this.hasNameInputTarget) return
    if (event.target !== this.nameInputTarget) return
    this.applyTitle(event.target.value)
  }

  syncFromDom() {
    if (!this.hasNameInputTarget) return
    this.applyTitle(this.nameInputTarget.value)
  }

  applyTitle(raw) {
    if (!this.hasTitleTarget) return
    const name = (raw ?? "").trim()
    this.titleTarget.textContent = name.length > 0 ? `Edit ${name}` : "Edit City"
  }
}
